import React from 'react';
import { IoIosMail } from "react-icons/io"; // Importer les icônes nécessaires

// ButtonEdit avec une icône d'édition
const ButtonMail = ({ onClick, className = '', hoverLabel = 'Envoyer un mail'  }) => {
  return (
    <button
      onClick={onClick}
      aria-label={hoverLabel}
      title={hoverLabel} 
      className={`w-8 h-8 bg-green-500 text-white rounded-md shadow-sm transition duration-300 ease-in-out hover:bg-green-700 flex items-center justify-center ${className}`}
    >
      <IoIosMail  className='text-[18px]'/>
    </button>
  );
};


export default ButtonMail;